export const AXIOS_DEFAULT_TIMEOUT = 3 * 1000

export default function({ $axios }) {
  $axios.defaults.timeout = AXIOS_DEFAULT_TIMEOUT
  $axios.onResponse(res => {
    if (toString.call(res.data) === '[object Object]') {
      res.data.headers = res.headers
    }
    return res
  })
}
